import React from 'react';

import Sad from './ressources/images/face-sad.png';
import Neutral from './ressources/images/face-neutral.png';
import Happy from './ressources/images/face-happy.png';

export default class Votes extends React.Component {
    render() {
        var face;
        
        if (this.props.index >= 0 && this.props.index < 7) {
            face = <img className="hi-img-face" src={Sad} title="sad" alt="sad" />
        } else if (this.props.index >= 7 && this.props.index < 9) {
            face = <img className="hi-img-face" src={Neutral} title="neutral" alt="neutral" />
        } else if (this.props.index >= 8 && this.props.index <= 10) {
            face = <img className="hi-img-face" src={Happy} title="happy" alt="happy" />
        }

        return(
            <div className="hi-rating-input">
                {face}
                <span>{this.props.index}</span>
                <input
                    type="number"
                    min = "0"
                    max = "999999"
                    step = "1"
                    placeholder = "0"
                    id={this.props.index}
                    onChange={this.props.change} />
            </div>
        );
    }
}